import React, { useMemo } from 'react'
import Grid from '@mui/material/Grid'
import { Stack, IconButton, Divider } from '@mui/material'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'

import { formatTimeFromJSArray } from '../../utilities/FormatDate'

import './TimePicker.sass'

const hours = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']
const minutes = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55']
const defaultFunction = () => { }

function TimePicker(props) {
  const { t } = useTranslation()
  const defaultToday = useMemo(() => new Date(), [])

  const {
    time = defaultToday,
    disabled = false,
    setTime = defaultFunction,
    timeArray = time ? formatTimeFromJSArray(time) : formatTimeFromJSArray(defaultToday),
  } = props

  const isPM = () => timeArray[2] === 'pm'

  const getHour24 = (hour, pm = isPM()) => {
    const normalizedHour = Number(hour) % 12
    return pm ? normalizedHour + 12 : normalizedHour
  }

  const setIsPM = nextIsPM => {
    if (nextIsPM === isPM()) return

    const currentHour = DateTime.fromJSDate(time).hour
    const hour = getHour24(currentHour, nextIsPM)
    const nextTime = DateTime.fromJSDate(time).set({ hour }).toJSDate()
    setTime(nextTime)
  }

  const setHour = hour => {
    const nextHour = getHour24(hour)
    const nextTime = DateTime.fromJSDate(time).set({ hour: nextHour }).toJSDate()
    setTime(nextTime)
  }

  const setMinute = minute => {
    const nextTime = DateTime.fromJSDate(time).set({ minute }).toJSDate()
    setTime(nextTime)
  }

  const isActiveHour = hour => Number(hour) === Number(timeArray[0])
  const isActiveMinute = minute => Number(minute) === Number(timeArray[1])

  return (
    <div className={`TimePicker ${disabled ? 'disabled' : ''}`}>
      <Stack spacing={2} direction='row' justifyContent='center'>
        <IconButton
          disabled={disabled}
          className={!isPM() ? 'am-pm active' : 'am-pm'}
          onClick={() => setIsPM(false)}
          size='small'
        >
          AM
        </IconButton>
        <IconButton
          disabled={disabled}
          className={isPM() ? 'am-pm active' : 'am-pm'}
          onClick={() => setIsPM(true)}
          size='small'
        >
          PM
        </IconButton>
      </Stack>
      <Divider />
      <Grid container spacing={3}>
        <Grid item xs>
          <label>{t('hour')}</label>
          {hours.map(hour => (
            <IconButton
              key={hour}
              disabled={disabled}
              className={`item-timePicker ${isActiveHour(hour) ? 'active' : ''}`}
              onClick={() => setHour(hour)}
              size='small'
            >
              {hour}
            </IconButton>
          ))}
        </Grid>
        <Grid item xs>
          <label>{t('minutes')}</label>
          {minutes.map(minute => (
            <IconButton
              key={minute}
              disabled={disabled}
              className={`item-timePicker ${isActiveMinute(minute) ? 'active' : ''}`}
              onClick={() => setMinute(minute)}
              size='small'
            >
              {minute}
            </IconButton>
          ))}
        </Grid>
      </Grid>
    </div>
  )
}

export default TimePicker
